import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddProjectLookupListFormValues } from '../../../../../interfaces/lookup/project';
import { IAddProject } from '../../../../../interfaces/lookup/project/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addProject } from '../../../../../store/lookupSlice/LookupActions';

export const ProjectLookupListAdd = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddProjectLookupListFormValues) => {
        const body: IAddProject = {
            ...(values as any),
        };

        dispatch(addProject(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.project.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/project', { replace: true });
        }
    }, [lookupSlice.detailsPage.project.createStatus]);

    return (
        <Form
            form={form}
            name="project-lookup-add"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage project lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Project',
                        path: '/admin/lookup-lists/project',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/project/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.project.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.project.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.project.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.project.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.project.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.project.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.project.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.project.fetchStatus} about={'Project'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">Project option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input maxLength={20} />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
